module.exports = __webpack_public_path__ + "img/Weiheng.65bd990b.jpg";